import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

export const HomeIcon: FC<
  IconProps & {
    active?: boolean;
    startColor?: string;
    endColor?: string;
  }
> = memo(
  ({
    active,
    width,
    height,
    size = 44,
    color = 'rgba(255, 255, 255, 0.4)',
    startColor,
    endColor,
    style,
  }) => {
    if (active) {
      return (
        <Svg
          width={width ?? size}
          height={height ?? size}
          viewBox="0 0 44 44"
          fill="none"
          style={style}
        >
          <Path
            d="M25.7714 40.8571V31.7488C25.7714 30.7317 25.3741 29.7562 24.6668 29.037C23.9595 28.3178 23.0002 27.9137 22 27.9137C20.9998 27.9137 20.0405 28.3178 19.3332 29.037C18.6259 29.7562 18.2286 30.7317 18.2286 31.7488V40.8571H6.91428C5.91404 40.8571 4.95476 40.4531 4.24748 39.7339C3.5402 39.0147 3.14285 38.0392 3.14285 37.0221V16.1822C3.14285 15.5199 3.31149 14.8689 3.63237 14.2926C3.95325 13.7163 4.41542 13.2343 4.97388 12.8936L20.0596 3.68939C20.6457 3.33176 21.3164 3.14285 22 3.14285C22.6836 3.14285 23.3543 3.33176 23.9404 3.68939L39.0261 12.8936C39.5846 13.2343 40.0467 13.7163 40.3676 14.2926C40.6885 14.8689 40.8571 15.5199 40.8571 16.1822V37.0221C40.8571 38.0392 40.4598 39.0147 39.7525 39.7339C39.0452 40.4531 38.086 40.8571 37.0857 40.8571H25.7714Z"
            fill="url(#paint0_linear_371_2611)"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_371_2611"
              x1="25.4286"
              y1="40.8571"
              x2="25"
              y2="5.71428"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor={startColor ?? color} />
              <Stop offset="1" stopColor={endColor ?? color} />
            </LinearGradient>
          </Defs>
        </Svg>
      );
    }

    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 44 44"
        fill="none"
      >
        <Path
          d="M37.0857 37.0221V16.1822L22 6.97801L6.91428 16.1822V37.0221H14.4571V31.7488C14.4571 29.7146 15.2518 27.7636 16.6664 26.3252C18.081 24.8868 19.9995 24.0787 22 24.0787C24.0005 24.0787 25.919 24.8868 27.3336 26.3252C28.7482 27.7636 29.5429 29.7146 29.5429 31.7488V37.0221H37.0857ZM25.7714 40.8572V31.7488C25.7714 30.7317 25.3741 29.7562 24.6668 29.037C23.9595 28.3178 23.0002 27.9138 22 27.9138C20.9998 27.9138 20.0405 28.3178 19.3332 29.037C18.6259 29.7562 18.2286 30.7317 18.2286 31.7488V40.8572H6.91428C5.91404 40.8572 4.95476 40.4531 4.24748 39.7339C3.5402 39.0147 3.14285 38.0392 3.14285 37.0221V16.1822C3.14285 15.52 3.31149 14.869 3.63237 14.2927C3.95325 13.7164 4.41542 13.2344 4.97388 12.8936L20.0596 3.68942C20.6457 3.33179 21.3164 3.14288 22 3.14288C22.6835 3.14288 23.3543 3.33179 23.9404 3.68942L39.0261 12.8936C39.5846 13.2344 40.0467 13.7164 40.3676 14.2927C40.6885 14.869 40.8571 15.52 40.8571 16.1822V37.0221C40.8571 38.0392 40.4598 39.0147 39.7525 39.7339C39.0452 40.4531 38.086 40.8572 37.0857 40.8572H25.7714Z"
          fill={color}
        />
      </Svg>
    );
  },
);
